import { styled, Box, Stack } from '../../../../base';

export const StyledPieViewWrapper = styled(Stack)(({ theme }) => ({
    padding: theme.spacing(2, 3),
    gap: theme.spacing(3),
}));

export const StyledHeaderBlock = styled(Stack)(({ theme }) => ({
    gap: theme.spacing(0.5),
}));

export const StyledPieRow = styled(Stack)(({ theme }) => ({
    flexWrap: 'wrap',
    gap: theme.spacing(3),
}));

export const StyledPieCard = styled(Stack)(({ theme }) => ({
    flex: '1 1 360px',
    minWidth: 0,
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 16,
}));

export const StyledPieCardHeader = styled(Stack)(({ theme }) => ({
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
}));

export const StyledDropdownSlot = styled(Box)({
    flex: '0 1 320px',
    minWidth: 0,
});

export const StyledPieCardBody = styled(Stack)(({ theme }) => ({
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(1, 2, 2),
    flexWrap: 'wrap',
}));

export const StyledPieEmptyState = styled(Stack)(({ theme }) => ({
    width: '100%',
    minHeight: 300,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(4, 2),
}));

export const StyledLegend = styled(Stack)(({ theme }) => ({
    gap: theme.spacing(1),
    minWidth: 120,
}));

export const StyledLegendItem = styled(Stack)(({ theme }) => ({
    alignItems: 'center',
    gap: theme.spacing(1),
}));

export const StyledColorDot = styled('span')<{ dotColor: string }>(
    ({ dotColor }) => ({
        width: 12,
        height: 12,
        borderRadius: 7,
        backgroundColor: dotColor,
        flexShrink: 0,
    })
);
